
(function () {
  'use strict';

  var registry = new WeakMap();

  function create(track, opts) {
    if (registry.has(track)) destroy(track);

    opts = Object.assign({
      perView: 1,
      gap: 0,
      paddingStart: 0,
      paddingEnd: 0,
      centered: false,
      prevEl: null,
      nextEl: null,
      paginationEl: null,
      onChange: null,
      onOverflow: null,
    }, opts);

    track.setAttribute('data-hf-slider', '');

    var gapsCount = Math.ceil(opts.perView) - 1;
    track.style.setProperty(
      '--hf-slider-slide-w',
      'calc((100% - ' + gapsCount + ' * ' + opts.gap + 'px) / ' + opts.perView + ')'
    );
    track.style.gap = opts.gap + 'px';

    if (opts.paddingStart) {
      track.style.paddingLeft = opts.paddingStart + 'px';
      track.style.scrollPaddingLeft = opts.paddingStart + 'px';
    }
    if (opts.paddingEnd) {
      track.style.paddingRight = opts.paddingEnd + 'px';
    }

    if (opts.centered) {
      track.setAttribute('data-hf-slider-centered', '');
    }

    var currentIndex = 0;

    function slides() {
      return Array.from(track.children);
    }

    function slideStep() {
      var s = slides();
      return s.length ? s[0].offsetWidth + opts.gap : 0;
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function hasOverflow() {
      return maxScroll() > 1;
    }

    function syncNav() {
      var overflow = hasOverflow();
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= maxScroll() - 1;

      if (opts.prevEl) {
        opts.prevEl.disabled = !overflow || atStart;
        opts.prevEl.setAttribute('aria-disabled', String(!overflow || atStart));
      }
      if (opts.nextEl) {
        opts.nextEl.disabled = !overflow || atEnd;
        opts.nextEl.setAttribute('aria-disabled', String(!overflow || atEnd));
      }
      if (opts.onOverflow) opts.onOverflow(overflow);
    }

    function syncPagination() {
      if (!opts.paginationEl) return;
      var total = Math.ceil(slides().length / Math.max(1, Math.floor(opts.perView)));
      var page = Math.min(Math.round(track.scrollLeft / (slideStep() * Math.floor(opts.perView))), total - 1);
      var dots = opts.paginationEl.children;

      if (dots.length !== total) {
        opts.paginationEl.innerHTML = '';
        for (var i = 0; i < total; i++) {
          var dot = document.createElement('span');
          dot.className = 'hf-slider-dot';
          dot.dataset.index = i;
          opts.paginationEl.appendChild(dot);
        }
      }

      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-active', j === page);
      }
    }

    function slideTo(index) {
      var s = slides();
      if (!s[index]) return;
      track.scrollTo({ left: s[index].offsetLeft - (opts.paddingStart || 0), behavior: 'smooth' });
    }

    function slidePrev() {
      slideTo(Math.max(0, currentIndex - 1));
    }

    function slideNext() {
      slideTo(Math.min(slides().length - 1, currentIndex + 1));
    }

    var scrollRaf = null;
    function onScroll() {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        var step = slideStep();
        if (step) {
          var newIndex = Math.round(track.scrollLeft / step);
          if (newIndex !== currentIndex) {
            currentIndex = newIndex;
            if (opts.onChange) opts.onChange(currentIndex);
          }
        }
        syncNav();
        syncPagination();
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    function onPrev(e) { e.preventDefault(); e.stopPropagation(); slidePrev(); }
    function onNext(e) { e.preventDefault(); e.stopPropagation(); slideNext(); }
    if (opts.prevEl) opts.prevEl.addEventListener('click', onPrev);
    if (opts.nextEl) opts.nextEl.addEventListener('click', onNext);

    function onDotClick(e) {
      var dot = e.target.closest('.hf-slider-dot');
      if (!dot) return;
      var pageIndex = parseInt(dot.dataset.index, 10);
      var slideIndex = pageIndex * Math.floor(opts.perView);
      slideTo(slideIndex);
    }
    if (opts.paginationEl) opts.paginationEl.addEventListener('click', onDotClick);

    var ro = new ResizeObserver(function () { syncNav(); syncPagination(); });
    ro.observe(track);

    syncNav();
    syncPagination();

    var inst = {
      track: track,
      slideTo: slideTo,
      slidePrev: slidePrev,
      slideNext: slideNext,
      update: function () { syncNav(); syncPagination(); },
      get index() { return currentIndex; },
      get overflow() { return hasOverflow(); },
      destroy: function () { destroy(track); }
    };

    registry.set(track, {
      inst: inst,
      opts: opts,
      ro: ro,
      onPrev: onPrev,
      onNext: onNext,
      onScroll: onScroll,
      onDotClick: onDotClick,
    });

    return inst;
  }

  function destroy(track) {
    var data = registry.get(track);
    if (!data) return;
    data.ro.disconnect();
    track.removeEventListener('scroll', data.onScroll);
    if (data.opts.prevEl) data.opts.prevEl.removeEventListener('click', data.onPrev);
    if (data.opts.nextEl) data.opts.nextEl.removeEventListener('click', data.onNext);
    if (data.opts.paginationEl) data.opts.paginationEl.removeEventListener('click', data.onDotClick);
    track.removeAttribute('data-hf-slider');
    track.removeAttribute('data-hf-slider-centered');
    track.style.removeProperty('--hf-slider-slide-w');
    track.style.removeProperty('gap');
    track.style.removeProperty('padding-left');
    track.style.removeProperty('scroll-padding-left');
    track.style.removeProperty('padding-right');
    registry.delete(track);
  }

  function get(track) {
    var data = registry.get(track);
    return data ? data.inst : null;
  }

  window.HfSlider = { create: create, destroy: destroy, get: get };
})();
